import React, { useState } from 'react';
import styles from './CharacterProfile.module.css';
import { shareIcon } from '../../assets/icons';

interface ShareButtonProps {
  username: string;
  type?: 'character' | 'user';
}

/**
 * ShareButton component for sharing character profiles
 * Copies a link to the clipboard and shows a notification
 */
const ShareButton: React.FC<ShareButtonProps> = ({ 
  username, 
  type = 'character' 
}) => {
  const [showCopiedNotification, setShowCopiedNotification] = useState<boolean>(false);

  const handleCopyLink = (): void => {
    const urlPath = type === 'character' ? 'chars' : 'users';
    const url = `${window.location.origin}/${urlPath}/${username}`;
    
    navigator.clipboard.writeText(url).then(() => {
      setShowCopiedNotification(true);
      setTimeout(() => {
        setShowCopiedNotification(false);
      }, 2000);
    });
  };

  return (
    <>
      {showCopiedNotification && (
        <div className={styles.notification}>
          <span className={styles.notificationIcon}>✓</span>
          Copied link to clipboard!
        </div>
      )}
      <button 
        className={styles.shareButton}
        onClick={handleCopyLink}
        type="button"
      >
        <img src={shareIcon} alt="Share" className={styles.shareIcon} />
        <span className={styles.buttonText}>Share</span>
      </button>
    </>
  );
};

export default ShareButton; 